import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './Separtediddeign.css';

const Separtedcarddesigntestionals = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [filteredTestimonials, setFilteredTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams(); // Get the ID from URL parameter
  const IMAGE_URL = 'https://mithahomesfrontend.pemixcels.com';

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch('https://mithahomesfrontend.pemixcels.com/api/testimonials/all');
        const data = await response.json();
        
        if (data.success) {
          // 1. Filter out testimonials with null title, subtitle, or details
          // 2. Filter ONLY to include testimonials where ttype is "image"
          const validTestimonials = data.data.filter(
            testimonial => 
              testimonial.ttitle && 
              testimonial.tsub && 
              testimonial.tdet &&
              testimonial.ttype === 'image' // *** CONDITION ADDED HERE ***
          );
          
          setTestimonials(validTestimonials);
          
          // Filter out the testimonial with matching tid from URL parameter
          if (id) {
            const filtered = validTestimonials.filter(
              testimonial => testimonial.tid !== parseInt(id)
            );
            setFilteredTestimonials(filtered);
          } else {
            setFilteredTestimonials(validTestimonials);
          }
        } else {
          setError('Failed to fetch testimonials');
        }
      } catch (err) {
        setError('Error connecting to API: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, [id]);

  // Function to truncate text for preview
  const truncateText = (text, maxLength = 150) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Function to format text with line breaks (kept but not used in final render logic)
  const formatTextWithLineBreaks = (text) => {
    if (!text) return '';
    return text.split('\n').map((str, index) => (
      <React.Fragment key={index}>
        {str}
        <br />
      </React.Fragment>
    ));
  };

  if (loading) {
    return (
     <div className="loading-message">Loading testimonials...</div>
    );
  }

  if (error) {
    return (
     <div className="error-message">Error: {error}</div>
    );
  }

  return (
    <div className="testimonials-container">
      {filteredTestimonials.length === 0 ? (
        <div className="no-testimonials">
          No image testimonials available at the moment.
        </div>
      ) : (
        <>
          <div className="testimonials-grid">
            {filteredTestimonials.map((testimonial) => (
              <div key={testimonial.tid} className="testimonial-card">
                <div className="testimonial-header">
                  <div className="avatar-container">
                    {testimonial.timg ? (
                      <img 
                        src={IMAGE_URL+testimonial.timg} 
                        alt={testimonial.ttitle} 
                        className="avatar"
                        onError={(e) => {
                          // Fallback to a placeholder on image load error
                          e.target.src = `https://via.placeholder.com/100/808080/FFFFFF?text=${testimonial.ttitle ? testimonial.ttitle.charAt(0) : 'U'}`;
                        }}
                      />
                    ) : (
                      <div className="avatar-placeholder">
                        {testimonial.ttitle ? testimonial.ttitle.charAt(0) : 'U'}
                      </div>
                    )}
                  </div>
                  <div className="testimonial-info">
                    <h3 className="testimonial-name">{testimonial.ttitle}</h3>
                    <p className="testimonial-role">{testimonial.tsub}</p>
                  </div>
                </div>
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    {truncateText(testimonial.tdet)}
                  </p>
                </div>
                {testimonial.tdet && testimonial.tdet.length > 150 && (
                  <a href={`/testimonials/${testimonial.tid}`} className="read-more">
                    Read more...
                  </a>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Separtedcarddesigntestionals;